<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.25 4.5C11.25 6.98175 9.23175 9 6.75 9C4.26825 9 2.25 6.98175 2.25 4.5C2.25 2.01825 4.26825 0 6.75 0C9.23175 0 11.25 2.01825 11.25 4.5ZM9.75 4.5C9.75 2.8455 8.4045 1.5 6.75 1.5C5.0955 1.5 3.75 2.8455 3.75 4.5C3.75 6.1545 5.0955 7.5 6.75 7.5C8.4045 7.5 9.75 6.1545 9.75 4.5ZM1.5 17.25C1.5 14.355 3.855 12 6.75 12C7.39272 12 7.79601 11.9335 7.875 11.625C8.09999 10.7464 7.4208 10.5 6.75 10.5C3.0285 10.5 0 13.5285 0 17.25C0 17.664 0.336 18 0.75 18C1.164 18 1.5 17.664 1.5 17.25ZM12 9.75V10.5H15C16.6545 10.5 18 11.8455 18 13.5V15C18 16.6545 16.6545 18 15 18H12C10.3455 18 9 16.6545 9 15V13.5C9 12.3923 9.60375 11.4225 10.5 10.9028V9.75C10.5 8.0955 11.8455 6.75 13.5 6.75C14.3513 6.75 15.1657 7.11375 15.735 7.749C16.0117 8.05725 15.9862 8.53125 15.678 8.808C15.369 9.084 14.895 9.0585 14.619 8.75025C14.3333 8.43225 13.926 8.25 13.5 8.25C12.6728 8.25 12 8.92275 12 9.75ZM12.375 14.25C12.375 14.871 12.879 15.375 13.5 15.375C14.121 15.375 14.625 14.871 14.625 14.25C14.625 13.629 14.121 13.125 13.5 13.125C12.879 13.125 12.375 13.629 12.375 14.25Z"
      fill="#303133"
    />
  </svg>
</template>
